export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  TEACHER = 'TEACHER',
  STUDENT = 'STUDENT',
  PARENT = 'PARENT',
}

export type DocumentType = 'CC' | 'TI' | 'CE' | 'PASAPORTE' | 'RC' | 'NIT';

export const DOCUMENT_TYPES: { value: DocumentType; label: string }[] = [
  { value: 'CC', label: 'Cédula de Ciudadanía' },
  { value: 'TI', label: 'Tarjeta de Identidad' },
  { value: 'CE', label: 'Cédula de Extranjería' },
  { value: 'PASAPORTE', label: 'Pasaporte' },
  { value: 'RC', label: 'Registro Civil' },
  { value: 'NIT', label: 'NIT' },
];

export interface User {
  id: string;
  email: string | null;
  first_name: string;
  last_name: string;
  role: UserRole;
  roles?: UserRole[];
  is_active: boolean;
  is_graduated?: boolean;
  graduation_year?: number | null;
  graduation_date?: string | null;
  avatar_url?: string | null;
  email_verified?: boolean;
  institution_id?: string;
  document_type?: DocumentType | null;
  document_number?: string | null;
  last_login_at?: string;
  created_at: string;
  updated_at?: string;
}

export interface GraduateStudentDto {
  graduationYear: number;
  graduationDate?: string;
}

export type ParentRelationship = 'PARENT' | 'GUARDIAN' | 'OTHER';

export interface ParentStudentLink {
  studentId: string;
  relationship: ParentRelationship;
}

export const RELATIONSHIP_LABELS: Record<ParentRelationship, string> = {
  PARENT: 'Padre/Madre',
  GUARDIAN: 'Acudiente',
  OTHER: 'Otro',
};

export interface CreateUserDto {
  email?: string;
  password: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  roles?: UserRole[];
  institutionId?: string;
  documentType?: DocumentType;
  documentNumber?: string;
  students?: ParentStudentLink[];
}

export interface UpdateUserDto {
  firstName?: string;
  lastName?: string;
  email?: string;
  role?: UserRole;
  institutionId?: string;
  isActive?: boolean;
  documentType?: DocumentType;
  documentNumber?: string;
}

export interface LoginDto {
  identifier: string;
  password: string;
}

export interface LoginResponse {
  accessToken: string;
  user: User;
  roleChanged?: boolean;
  previousRole?: string;
}

export interface SwitchRoleResponse {
  role: UserRole;
  roles: UserRole[];
  user: User;
}

export const ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.SUPER_ADMIN]: 'Super Administrador',
  [UserRole.ADMIN]: 'Administrador',
  [UserRole.TEACHER]: 'Profesor',
  [UserRole.STUDENT]: 'Estudiante',
  [UserRole.PARENT]: 'Padre/Tutor',
};

export const ROLE_ICONS: Record<UserRole, string> = {
  [UserRole.SUPER_ADMIN]: 'manage_accounts',
  [UserRole.ADMIN]: 'admin_panel_settings',
  [UserRole.TEACHER]: 'school',
  [UserRole.STUDENT]: 'backpack',
  [UserRole.PARENT]: 'family_restroom',
};

export interface ForgotPasswordDto {
  email: string;
}

export interface ResetPasswordDto {
  token: string;
  password: string;
}

export interface ChangePasswordDto {
  currentPassword: string;
  newPassword: string;
}
